export default {
  namespace: 'down',
  state: {
    data: {
      list: [],
      pagination: {},
    },
    showPage: 'search',
    editEntity: {},
    searchFilter: undefined,
  },

  effects: {
    *onshowPage({ payload, callback }, { call, put }) {
      yield put({
        type: 'showPage',
        showPage: payload.showPage,
        editEntity: payload.editEntity,
        searchFilter: payload.searchFilter,
        update: payload.update,
        fromPage: payload.fromPage,
      });
    },
  },

  reducers: {
    success(state, action) {
      return {
        ...state,
        data: action.payload,
      };
    },
    showPage(state, action) {
      return {
        ...state,
        showPage: action.showPage,
        editEntity: action.editEntity,
        searchFilter: action.searchFilter,
        update: action.update,
        fromPage: action.fromPage,
      };
    },
  },
};
